import { addDays, format, isAfter, isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const formatDateToET = (date: Date): string => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const dateStr = formatInTimeZone(date, timeZone, 'MMM d, yyyy');
  const timeStr = formatInTimeZone(date, timeZone, 'h:mma')
    .replace('AM', 'am')
    .replace('PM', 'pm');

  const timeZoneName =
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    })
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value ?? '';

  return `${dateStr} · ${timeStr} ${timeZoneName}`;
};

export const formatDateTime = (date: Date): string => {
  return format(date, 'MMM d, h:mma').replace('AM', 'am').replace('PM', 'pm');
};

export const formatDate = (date: Date): string => {
  return format(date, 'MMM d, yyyy, h:mma')
    .replace('AM', 'am')
    .replace('PM', 'pm');
};

export const startOfDayUTC = (date: Date) => {
  const ret = new Date(date);
  ret.setUTCHours(0, 0, 0, 0);
  return ret;
};

export const isReferenceDateOlderThanTwoDays = (referenceDate?: string) => {
  if (!referenceDate) {
    return false;
  }

  const ref = new Date(referenceDate);

  if (!isValid(ref)) {
    return false;
  }

  const refStartUTC = startOfDayUTC(ref);
  const nowStartUTC = startOfDayUTC(new Date());
  return isAfter(nowStartUTC, addDays(refStartUTC, 2));
};
